import { theme } from 'antd';

/**
 * Configuração de temas light e dark com cores verdes da Codilo.
 * 
 * Cores principais:
 * - Primária: #4DAB4B (verde Codilo)
 * - Variações: #29784c, #33925d, #3cad6e
 */

// Tema Light
export const lightTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#4DAB4B',
    colorSuccess: '#4DAB4B',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    borderRadius: 6,
    wireframe: false,
  },
  components: {
    Button: {
      primaryColor: '#ffffff',
      borderRadius: 6,
    },
    Card: {
      borderRadius: 8,
    },
    Menu: {
      itemSelectedBg: '#4DAB4B',
      itemSelectedColor: '#ffffff',
      itemHoverBg: '#e6f7e6',
      itemHoverColor: '#4DAB4B',
      itemActiveBg: 'transparent',
      motionDurationMid: '0s',
      motionDurationSlow: '0s',
    },
    Layout: {
      siderBg: '#ffffff',
      headerBg: '#ffffff',
      bodyBg: '#f5f5f5',
    },
  },
};

// Tema Dark
export const darkTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#4DAB4B',
    colorSuccess: '#4DAB4B',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    borderRadius: 6,
    wireframe: false,
  },
  components: {
    Button: {
      primaryColor: '#ffffff',
      borderRadius: 6,
    },
    Card: {
      borderRadius: 8,
    },
    Menu: {
      itemSelectedBg: '#4DAB4B',
      itemSelectedColor: '#ffffff',
      itemHoverBg: '#2d5a2f',
      itemHoverColor: '#4DAB4B',
      itemActiveBg: 'transparent',
      motionDurationMid: '0s',
      motionDurationSlow: '0s',
    },
    Layout: {
      siderBg: '#1f1f1f',
      headerBg: '#141414',
      bodyBg: '#000000',
    },
  },
};

export type ThemeMode = 'light' | 'dark';

